import { on } from 'delegated-events';
import helpers from './helpers.js'


export default (function () {
  let warning;
  return {
    init() {
      warning = document.querySelector('.js-opco-alert');

      if (warning == null) return;

      on('click', '.js-launch-warning', (e) => {
        e.preventDefault();
        this.open();
      });

      on('click', '.js-opco-alert-close', (e) => {
        e.preventDefault();
        this.close();
      });

      on('click', '.js-opco-warning', (e) => {
        e.preventDefault();
        const path = e.currentTarget.getAttribute('href');
        const title = e.currentTarget.getAttribute('data-name');
        this.populateWarning(path, title);
        this.open();
      });
    },
    open() {
      document.documentElement.classList.add('is-warning-open');
      if (spirax.location.locationFocusTrap !== undefined) {
        spirax.location.locationFocusTrap.pause();
      }
      window.setTimeout(() => {
        document.querySelector('.js-opco-alert button, .js-opco-alert a').focus();
      }, 300);
    },
    close() {
      document.documentElement.classList.remove('is-warning-open');
      if (spirax.location.locationFocusTrap !== undefined) {
        spirax.location.locationFocusTrap.unpause();
      }
      window.setTimeout(() => {
        this.resetWarning();
      }, 300);
    },
    populateWarning(path, title) {
      const names = warning.querySelectorAll('.js-opco-alert-name');
      const links = warning.querySelectorAll('.js-opco-alert-proceed');
      if (names != null) {
        [...names].forEach((name) => {
          name.innerText = title;
        });
      }
      if (links != null) {
        [...links].forEach((link) => {
          link.href = path;
        });
      }
    },
    resetWarning() {
      const names = warning.querySelectorAll('.js-opco-alert-name');
      const links = warning.querySelectorAll('.js-opco-alert-proceed');
      if (names != null) {
        [...names].forEach((name) => {
          name.innerText = '';
        });
      }
      if (links != null) {
        [...links].forEach((link) => {
          link.href = '#';
        });
      }
    },
  };
}());
